import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SimulationService {
  constructor() {}

  public simulationData: any;

  setSimulationData(data: any) {
    this.simulationData = data;
  }

  getSimulationData() {
    return this.simulationData;
  }
}
